<div class="h-screen overflow-hidden">
  <vw-header-padding-safe-area></vw-header-padding-safe-area>
  <div class="pb-8 overflow-hidden h-full">
    <!-- Page title -->
    <h2 class="text-[#062825] text-[32px] font-semibold pb-3 px-4">{{ 'calendar.title' | translate }}</h2>

    <div class="flex items-center justify-between px-4 pt-2 mb-1 gap-4 relative z-20">
      <div class="grow"><vw-text-input (valueChange)="onSearch($event)" icon="search" [prefix]="prefix"
          placeholder="agenda.search.placeholder">
          <ng-template #prefix>
            <div class="w-5 h-5 flex items-center justify-center text-gray-500">
              <vw-plant-icon></vw-plant-icon>
            </div>
          </ng-template>
        </vw-text-input></div>
      <div class="size-10 p-2.5 bg-grey-100 rounded-lg flex items-center justify-center text-gray-600"
        (click)="isSortingModalOpen = true">
        <vw-sort-icon></vw-sort-icon>
      </div>
    </div>
    <vw-calendar-hierarchies [hierarchies]="currentMonthCalendarItems" [isLoading]="isLoading"
      (cultivationSelected)="onCultivationSelected($event)">
    </vw-calendar-hierarchies>


    <vw-cultivation-guide-toast [isOpen]="isShowingGuide" [cultivation]="selectedCultivation"
      [cultivationVariant]="selectedVariant" (close)="isShowingGuide = false">
    </vw-cultivation-guide-toast>
    <vw-calendar-sort-toast [isOpen]="isSortingModalOpen" (close)="isSortingModalOpen = false"
      (sortChange)="onSortChange($event.sort, $event.sortDirection)"></vw-calendar-sort-toast>
  </div>
</div>